let pendingCustomData = null

function flushPendingCustomData() {
  if (!pendingCustomData || !window.jivo_api?.setCustomData) return
  window.jivo_api.setCustomData(pendingCustomData)
  pendingCustomData = null
}

export function initJivo() {
  const widgetId = process.env.VUE_APP_JIVO_WIDGET_ID
  if (!widgetId || document.getElementById('jivo-widget')) return

  window.jivo_onLoadCallback = () => {
    flushPendingCustomData()
  }

  const script = document.createElement('script')
  script.id = 'jivo-widget'
  script.src = `https://code.jivo.ru/widget/${widgetId}`
  script.async = true
  document.head.appendChild(script)
}

export function syncJivoCustomData({ userId, companyId } = {}) {
  const fields = []
  if (userId) fields.push({ key: 'ID пользователя', content: String(userId) })
  if (companyId) fields.push({ key: 'ID компании', content: String(companyId) })
  if (!fields.length) return

  if (window.jivo_api?.setCustomData) {
    window.jivo_api.setCustomData(fields)
  } else {
    pendingCustomData = fields
  }
}

export function isJivoEnabled() {
  return !!process.env.VUE_APP_JIVO_WIDGET_ID
}

export function openJivoChat() {
  window.jivo_api?.open?.()
}
